module.exports = __webpack_public_path__ + "img/zzjg.a3e35a68.png";